import { useState, useEffect, useCallback } from 'react';

export default function usePdfPageInput({ currentPage, numPages, setCurrentPage, pageRefs }) {
  const [pageInputValue, setPageInputValue] = useState('1');

  useEffect(() => {
    setPageInputValue(String(currentPage));
  }, [currentPage]);

  const handlePageInputChange = useCallback((e) => {
    setPageInputValue(e.target.value);
  }, []);

  const handlePageInputSubmit = useCallback((e) => {
    if (e.key !== 'Enter') return;

    const pageNum = parseInt(pageInputValue, 10);
    if (!Number.isNaN(pageNum) && pageNum >= 1 && pageNum <= (numPages || 1)) {
      setCurrentPage(pageNum);
      const pageContainer = pageRefs.current[pageNum];
      if (pageContainer) {
        pageContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      setPageInputValue(String(currentPage));
    }
  }, [pageInputValue, numPages, setCurrentPage, pageRefs, currentPage]);

  return {
    pageInputValue,
    handlePageInputChange,
    handlePageInputSubmit,
  };
}
